import React from "react";
import "./windowPeek.css";

const WindowPeek = () => {
  return <div className="window-peek"></div>;
};

export default WindowPeek;
